import { render, staticRenderFns } from "./DiscoverNTrain.vue?vue&type=template&id=568dd58b&"
import script from "./DiscoverNTrain.vue?vue&type=script&lang=js&"
export * from "./DiscoverNTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports